import { utils } from '@neo-one/utils';
import { ArrayLikeStackItem } from './ArrayLikeStackItem';
import { StackItemType } from './StackItemType';
export class StructStackItem extends ArrayLikeStackItem {
    clone() {
        return new StructStackItem(this.value.map((value) => (value instanceof StructStackItem ? value.clone() : value)));
    }
    toStructuralKey() {
        return JSON.stringify(this.value.map((value) => value.toStructuralKey()));
    }
    equals(other) {
        if (other === undefined) {
            return false;
        }
        if (this === other) {
            return true;
        }
        if (other instanceof StructStackItem) {
            if (this.value.length !== other.value.length) {
                return false;
            }
            return utils.zip(this.value, other.value).every(([a, b]) => a.equals(b));
        }
        return this === other;
    }
}
StructStackItem.type = StackItemType.Struct;

//# sourceMappingURL=StructStackItem.js.map
